export default __webpack_public_path__ + "static/media/img_baseCottonBunnyEars_cotton.dd2ddfae.jpg";